import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Stack,
  Typography,
  Container,
  Toolbar,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import cssStyles from '@/utils/cssStyles';
import Image from '@/components/Image';
import Iconify from '@/components//Iconify';
import useEventContext from '@/contexts/event/useEventContext';
import BoletiaIcon from '@/components/BoletiaIcon';
import { formatUTCDate } from '@/locales/dates';
import LanguageSelector from './LanguageSelector';

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
}));

function HeaderMobile({ onInfo = () => {}, children }) {
  const [eventDate, setEventDate] = useState(null);
  const theme = useTheme();
  const {
    event: {
      event: { start_date, name, banner, use_seats },
    },
  } = useEventContext();

  useEffect(() => {
    setEventDate(formatUTCDate(start_date, 'ddd, DD MMMM YYYY. h:mm A'));
  }, []);

  return (
    <AppBar
      sx={{
        background: (theme) => theme.palette.background.paper,
      }}
    >
      <ToolbarStyle
        disableGutters
        sx={{
          ...cssStyles(theme).bgBlur(),
          height: use_seats ? '68px' : '48px',
        }}
      >
        {children || (
          <>
            {!use_seats && (
              <Container>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ alignItems: 'center' }}
                >
                  <BoletiaIcon
                    sx={{
                      width: '94px',
                    }}
                    onClick={() => {
                      window.open(`https://boletia.com`, '_self');
                    }}
                    fill={
                      theme.palette.mode === 'light'
                        ? theme.palette.orange[0]
                        : theme.palette.common.white
                    }
                  />
                  <Box sx={{ flexGrow: 1 }}></Box>
                  <LanguageSelector />
                </Stack>
              </Container>
            )}
            {use_seats && (
              <Container>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ alignItems: 'center' }}
                >
                  <Box
                    sx={{
                      flexGrow: 1,
                      maxWidth: 48,
                      borderRadius: '4px',
                      overflow: 'hidden',
                    }}
                  >
                    <Image src={banner} ratio="1/1" />
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Stack>
                        <Typography
                          variant="subtitle2"
                          component="div"
                          sx={{
                            fontWeight: 600,
                            fontSize: '12px',
                            color: (theme) => theme.palette.grey[900],
                          }}
                        >
                          {name}
                        </Typography>
                        <Typography
                          variant="body3"
                          sx={{
                            textTransform: 'capitalize',
                            fontSize: '11px',
                            color: (theme) => theme.palette.grey[500],
                          }}
                        >
                          {eventDate}
                        </Typography>
                      </Stack>

                      <Iconify
                        onClick={onInfo}
                        width={18}
                        height={18}
                        icon={'material-symbols:info-outline'}
                        sx={{
                          color: (theme) => theme.palette.secondary.main,
                        }}
                      />
                    </Stack>
                  </Box>
                  <LanguageSelector />
                </Stack>
              </Container>
            )}
          </>
        )}
      </ToolbarStyle>
    </AppBar>
  );
}

export default HeaderMobile;
